{
  "AUTH_INVALID_CREDENTIALS": "Correo electrónico o contraseña incorrectos.",
  "AUTH_ACCOUNT_BLOCKED": "Tu cuenta está bloqueada.",
  "AUTH_ACCOUNT_INACTIVE": "Tu cuenta está desactivada. Ponte en contacto con el soporte.",
  "AUTH_USER_NOT_FOUND": "Usuario no encontrado.",
  "AUTH_TWO_FACTOR_REQUIRED": "Se necesita el código de verificación.",
  "AUTH_TWO_FACTOR_CODE_INVALID": "El código de verificación no es válido.",
  "AUTH_TOKEN_INVALID": "El token no es válido.",
  "AUTH_TOKEN_EXPIRED": "El token expiró.",
  "AUTH_TOKEN_REQUIRED": "El token es obligatorio.",
  "AUTH_LOGOUT_SUCCESS": "Cerraste sesión correctamente.",
  "AUTH_PASSWORD_RESET_REQUESTED": "Si el correo existe, recibirás un enlace para establecer la contraseña.",
  "AUTH_RESET_TOKEN_INVALID": "El token no es válido o expiró.",
  "AUTH_PASSWORD_CHANGED": "Contraseña cambiada correctamente.",
  "AUTH_PASSWORD_INCORRECT": "Contraseña incorrecta.",
  "AUTH_TWO_FACTOR_ALREADY_ENABLED": "La verificación en dos pasos ya está activada.",
  "AUTH_TWO_FACTOR_SETUP_EXPIRED": "La sesión de configuración expiró.",
  "AUTH_CODE_INVALID": "Código no válido.",
  "AUTH_TWO_FACTOR_ENABLED": "Verificación en dos pasos activada correctamente.",
  "AUTH_TWO_FACTOR_DISABLED": "Verificación en dos pasos desactivada correctamente.",
  "AUTH_DEEP_LINK_INVALID": "El enlace de acceso directo no es válido o expiró.",
  "AUTH_DEEP_LINK_USED": "El token ya se ha utilizado o expiró.",
  "AUTH_MAGIC_LINK_SENT": "Si el correo existe, se ha enviado el enlace mágico.",
  "AUTH_MAGIC_LINK_INVALID": "El enlace mágico no es válido o expiró.",
  "AUTH_MAGIC_LINK_LOGIN_SUCCESS": "Iniciaste sesión con el enlace mágico.",
  "AUTH_EMAIL_REQUIRED": "El correo electrónico es obligatorio.",
  "AUTH_TOO_MANY_LOGIN_ATTEMPTS": "Demasiados intentos de inicio de sesión. Inténtalo de nuevo en unos minutos.",
  "AUTH_OAUTH_NOT_CONFIGURED": "{{provider}} OAuth no está configurado.",
  "AUTH_OAUTH_PROVIDER_UNSUPPORTED": "Proveedor no compatible.",
  "AUTH_OAUTH_PROVIDER_INVALID": "Proveedor no válido.",
  "AUTH_OAUTH_CODE_REQUIRED": "El código de autorización es obligatorio.",
  "AUTH_OAUTH_STATE_REQUIRED": "El parámetro state es obligatorio.",
  "AUTH_OAUTH_STATE_INVALID": "El parámetro state no es válido.",
  "AUTH_OAUTH_CODE_OR_STATE_REQUIRED": "El código o el parámetro state son obligatorios.",
  "AUTH_SOCIAL_CALLBACK_OK": "El endpoint de callback del inicio de sesión social funciona.",
  "AUTH_MFA_METHOD_UNAVAILABLE": "Método no disponible.",
  "AUTH_MFA_CODE_COOLDOWN": "Espera {{seconds}} segundos antes de solicitar otro código.",
  "AUTH_MFA_PHONE_MISSING": "No hay ningún teléfono registrado.",
  "AUTH_MFA_CODE_SENT": "Código enviado.",
  "AUTH_MFA_TOO_MANY_ATTEMPTS": "Demasiados intentos. Vuelve a iniciar sesión.",
  "AUTH_MFA_METHOD_ALREADY_VERIFIED": "Este método ya está verificado.",
  "AUTH_MFA_CODE_INVALID": "Código o contraseña incorrectos.",
  "AUTH_MFA_SESSION_EXPIRED": "La sesión expiró. Vuelve a iniciar sesión.",
  "AUTH_MFA_SESSION_INVALID": "La sesión no es válida. Vuelve a iniciar sesión.",
  "AUTH_MFA_SESSION_UNAVAILABLE": "No se pudo continuar con el inicio de sesión. Inténtalo de nuevo en unos instantes.",
  "AUTH_WEBHOOK_TOKEN_INVALID": "El token del webhook no es válido.",
  "AUTH_WEBHOOK_UNAVAILABLE": "El webhook de usuarios no está disponible: firma no configurada.",
  "AUTH_WEBHOOK_SIGNATURE_REQUIRED": "La firma del webhook es obligatoria.",
  "AUTH_WEBHOOK_SIGNATURE_INVALID": "La firma del webhook no es válida.",
  "AUTH_WEBHOOK_SOURCE_REQUIRED": "El origen del webhook es obligatorio.",
  "AUTH_WEBHOOK_USERS_REQUIRED": "Payload no válido: la lista de usuarios es obligatoria.",
  "AUTH_WEBHOOK_FIELDS_REQUIRED": "El nombre y el correo electrónico son obligatorios.",
  "AUTH_WEBHOOK_USER_EXISTS": "Ya existe un usuario con este correo electrónico.",
  "AUTH_WEBHOOK_USER_CREATE_FAILED": "No se pudo crear el usuario.",
  "AUTH_WEBHOOK_USER_CREATED": "Usuario creado correctamente mediante webhook.",
  "AUTH_WEBHOOK_PING_OK": "El endpoint del webhook funciona.",
  "AUTH_EMAIL_INVALID": "Correo electrónico no válido.",
  "AUTH_PASSWORD_TOO_SHORT": "La contraseña debe tener al menos 8 caracteres.",
  "AUTH_PASSWORD_WEAK": "La contraseña debe contener al menos una mayúscula, una minúscula y un número.",
  "AUTH_REFRESH_TOKEN_REQUIRED": "El token de actualización es obligatorio.",
  "AUTH_TWO_FACTOR_CODE_LENGTH": "El código debe tener 6 dígitos.",
  "AUTH_TWO_FACTOR_BACKUP_CODE_LENGTH": "El código debe tener entre 6 y 8 caracteres.",
  "AUTH_MFA_SEND_METHOD_INVALID": "El método debe ser email o sms.",
  "AUTH_MFA_METHOD_INVALID": "Método no válido.",
  "USER_NOT_FOUND": "Usuario no encontrado.",
  "USER_EMAIL_IN_USE": "Este correo electrónico ya está en uso.",
  "USER_CPF_IN_USE": "Este CPF ya está en uso.",
  "USER_BLOCKED": "Usuario bloqueado.",
  "USER_CURRENT_PASSWORD_INCORRECT": "La contraseña actual es incorrecta.",
  "USER_DELETED": "Usuario eliminado correctamente.",
  "USER_NAME_TOO_SHORT": "El nombre debe tener al menos 2 caracteres.",
  "USER_CPF_INVALID": "El CPF debe tener 11 dígitos numéricos.",
  "USER_PHONE_INVALID": "El teléfono debe tener 10 u 11 dígitos.",
  "USER_PHONE_INTERNATIONAL_INVALID": "El teléfono debe estar en formato internacional (+ y de 8 a 15 dígitos).",
  "TERMS_IP_REQUIRED": "La dirección IP es obligatoria.",
  "TERMS_CONTRACT_FILE_TYPE_INVALID": "Solo se permiten archivos PDF o DOC/DOCX.",
  "TERMS_CONTRACT_FILE_TOO_LARGE": "El archivo debe tener como máximo {{maxMb}} MB.",
  "ONBOARDING_PROGRESS_NOT_FOUND": "No se encontró el progreso del onboarding.",
  "ONBOARDING_PROGRESS_ALREADY_EXISTS": "El progreso del onboarding ya existe para este usuario.",
  "ONBOARDING_TEMPLATE_NOT_FOUND": "Plantilla no encontrada.",
  "DEVFLIX_SSO_STUDENT_NOT_FOUND": "No se encontró un alumno activo.",
  "DEVFLIX_SSO_EMAIL_NOT_VERIFIED": "Confirma tu correo electrónico en el área de miembros antes de entrar en DevFlix.",
  "DEVFLIX_SSO_CODE_INVALID": "El código de autorización no es válido.",
  "DEVFLIX_SSO_NOT_CONFIGURED": "La integración con DevFlix no está configurada con cliente, secreto y redirecciones seguras.",
  "DEVFLIX_SSO_CLIENT_NOT_AUTHORIZED": "Cliente o redirección de DevFlix no autorizados.",
  "DEVFLIX_SSO_CLIENT_UNAUTHENTICATED": "Cliente no autenticado.",
  "DEVFLIX_SSO_SCOPE_INVALID": "Ámbito de DevFlix no válido.",
  "PLATFORM_OPERATOR_NOT_FOUND": "Operador no encontrado.",
  "PLATFORM_OPERATOR_INACTIVE": "Operador inactivo.",
  "PLATFORM_TENANT_NOT_FOUND": "Ninguna área de miembros responde en esta dirección.",
  "PLATFORM_SCHOOL_NAME_REQUIRED": "Indica el nombre de la escuela.",
  "PLATFORM_ADMIN_EMAIL_REQUIRED": "Indica el correo electrónico del administrador de la escuela.",
  "PLATFORM_ADMIN_PASSWORD_TOO_SHORT": "La contraseña inicial del administrador debe tener al menos {{min}} caracteres.",
  "PLATFORM_SUBDOMAIN_INVALID": "Subdominio no válido.",
  "PLATFORM_SUBDOMAIN_RESERVED": "El subdominio \"{{slug}}\" está reservado.",
  "PLATFORM_SUBDOMAIN_TAKEN": "El subdominio \"{{slug}}\" ya está en uso.",
  "PLATFORM_SUBDOMAIN_UNAVAILABLE": "No se pudo obtener un subdominio libre a partir de \"{{source}}\".",
  "PLATFORM_TENANT_SUSPENDED": "Cliente suspendido.",
  "PLATFORM_TENANT_BLOCKED": "Esta área de miembros está bloqueada. Habla con soporte.",
  "PLATFORM_TENANT_REACTIVATED": "Cliente reactivado.",
  "AUTH_INVITE_INVALID": "Enlace de acceso no válido o ya utilizado.",
  "AUTH_INVITE_EXPIRED": "Enlace de acceso expirado. Solicita uno nuevo.",
  "AUTH_PASSWORD_NOT_SET": "Aún no definiste tu contraseña. Usa el enlace enviado a tu correo o recupera el acceso en \"¿Olvidaste tu contraseña?\".",
  "PLATFORM_PRODUCER_WEBHOOK_SIGNATURE_INVALID": "Firma del webhook no válida."
}
